import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { PasswordReqType } from "../../types/Login.ts";
import { useSubmitState } from "../../hooks/useSubmitState.ts";
import { IconLockOpen, IconLogin2, IconUserMinus } from "@tabler/icons-react";
import { deleteAll } from "../../fetch/fetch.authentication.ts";
import { isError } from "../../types/Result.ts";
import PopUp, { closeEveryModal, openModal } from "../core/PopUp.tsx";
import { useAuthToken } from "../../hooks/useAuthToken.ts";
import { ERROR_ICON } from "../../types/Error/ErrorIcons.tsx";
import { ERROR_TEXT, ErrorType } from "../../types/Error/Errors.ts";
import PasswordInput from "../auth/input/PasswordInput.tsx";
import { LOADING_CIRCLE } from "../core/loading/LoadingCircle.tsx";

const initButton = (
  <>
    <IconLogin2 />
    Account Löschen
  </>
);
const loadingButton = (
  <>
    {LOADING_CIRCLE}
    lösche Daten...
  </>
);
const successButton = (
  <>
    <IconLockOpen />
    Dein Account wurde gelöscht.
  </>
);

const errorButton = (error: ErrorType) => {
  const message = ERROR_TEXT[error];
  console.warn(error);
  return (
    <>
      {ERROR_ICON[error]}
      {message}
    </>
  );
};

const AccountDelete = () => {
  const form = useForm<PasswordReqType>({
    mode: "all",
  });
  const submitState = useSubmitState({ initButtonChild: initButton });
  const authToken = useAuthToken();
  const handleDelete: SubmitHandler<PasswordReqType> = async (data) => {
    if (submitState.loading) return;
    submitState.init(loadingButton);
    const res = await deleteAll(data.password);
    if (isError(res)) {
      submitState.fetchFailed(res.error, errorButton(res.error));
      return;
    }
    submitState.fetchSuccess(successButton);
    setTimeout(() => {
      closeEveryModal();
      submitState.fetchSuccess(
        `Es wurden ${res.value.messageCount} Nachrichten und ${res.value.fileCount} Bilder gefunden und gelöscht. Dein Account und Userprofil wurde entfernt. Anzeigen und Nachrichten werden innerhalb der nächsten 30 Tagen automatisch gelöscht. `,
      );
      openModal("account_delete_ok");
    }, 1500);
  };

  const handleFinish = () => {
    if (authToken.status === "ok") {
      authToken.logout();
    }
    closeEveryModal();
  };

  return (
    <div className="grid p-4 gap-4 w-full">
      <PopUp
        id={"account_delete_ok"}
        title={
          <>
            <IconUserMinus />
            Account gelöscht
          </>
        }
      >
        <div>{submitState.buttonChild}</div>
        <button
          onClick={handleFinish}
          className={`btn btn-primary w-full`}
          disabled={authToken.status !== "ok"}
        >
          Lokale Logindaten löschen
        </button>
      </PopUp>
      <h2 className="text-2xl font-bold">Bestätige mit Passwort</h2>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleDelete)}>
          <PasswordInput autoComplete={"current-password"} />
          <div className="form-control">
            <button
              className={`btn btn-primary w-full`}
              disabled={!form.formState.isValid || submitState.submitted}
            >
              {submitState.buttonChild}
            </button>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};
export default AccountDelete;
